import {DateTime} from "luxon";
import Constants from "../../../services/Constants";
import Helpers from "../../../services/Helpers";

export default function SubscriptionMessage({ memberStore, subStore }) {
  const { subscriptionMessages } = Constants();
  const { isNotEmpty } = Helpers();

  switch (subStore.subscriptionMessage) {
    case subscriptionMessages.ERROR_CARD:
      return (

        <div className="col-12 text-center">
        <div className="alert alert-primary no-margin no-border-radius" role="alert">
          💳 Oh no! Your card was declined. Please update your billing information (below) and try again. 💳
        </div>
        </div>
      );
    case subscriptionMessages.ERROR:
      return (
          <div className="col-12 text-center">
            <div className="alert alert-primary no-margin no-border-radius"
                 role="alert">
              🤔 Something went wrong, email us at <a
                href="mailto:support@cleanfooddirtygirl.com">support@cleanfooddirtygirl.com</a> and
              we'll help you out. 🤔
            </div>
          </div>
      );
    case subscriptionMessages.CHANGE_SUBSCRIPTION_SUCCESS:
      return (
          <div className="col-12 text-center">
            <div className="alert alert-success no-margin no-border-radius"
                 role="alert">
              🎉🥕 Success! You membership plan has been updated. 🥬✨
            </div>
          </div>
      );
    case subscriptionMessages.ADD_SUBSCRIPTION_SUCCESS:
      //TODO a little ambiguous here - to be checked
      if (isNotEmpty(memberStore.member.since)) {
        const since = DateTime.fromSeconds(memberStore.member.since);
        if (since.startOf("day") < DateTime.now().startOf("day")) {
          // The member reactivated
          return (
        <div className="col-12 text-center">
          <div className="alert alert-success no-margin no-border-radius" role="alert">
             🎉🥕 Welcome back! We're so happy to have you! 🥬✨
         </div>
        </div>

          );
        } else {
          // This is a new member
          return (
          <div className="col-12 text-center">
            <div className="alert alert-success no-margin no-border-radius" role="alert">
             🎉🥕 Congrats! We're so happy to have you as a member! 🥬✨
          </div>
        </div>
          );
        }
      }
    default:
      return null;
  }
}
